/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback } from 'react';
import Countdown from 'react-count-down';
import { getIconStatus } from '../../../../../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAlertModule } from '../../../../../../store/actions/alert.actions';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { useMarkingContext } from '../MarkingContext/MarkingContext';
import { Chip, Tooltip, Typography } from '@mui/material';
import ButtonSyncMarkingData from '../../SyncMarkngData/ButtonSyncMarkingData';

const ButtonSave = ({ disabled }) => {
  const { loadingSave, updatePeriodicalReportMarking, isLoading, currentPeriodicalReport, permission } = useMarkingContext();
  const mode = useSelector((state) => state?.periodicalReport?.mode);
  const students = useSelector((state) => state?.periodicalReport?.students || []);
  const alertSave = useSelector((state) =>
    state.alert ? (state.alert.save ? state.alert.save : false) : false
  );

  const dispatch = useDispatch();
  const onSaveCB = useCallback(() => updatePeriodicalReportMarking(students), [students]);

  useEffect(() => {
    if (alertSave && mode?.text === 'editing' && students.length > 0) {
      dispatch(toggleAlertModule(false, 'Periodical report marking', 'editing', onSaveCB));
    }
  }, [alertSave, students, mode, onSaveCB]);

  const OPTIONS = {
    endDate: mode?.endDate || new Date(),
    cb: () => {
      onSaveCB();
    }
  };

  return (
    <div className='flex justify-end gap-2 pr-2'>
      <ButtonSyncMarkingData loading={isLoading} periodicalReport={currentPeriodicalReport} />

      {mode?.endDate && (
        <div style={{ display: 'none' }}>
          {' '}
          <Countdown options={OPTIONS} />
        </div>
      )}
      {mode && (
        <>
          {mode?.text === 'error' ? (
            <Tooltip arrow title={mode.error} id='periodical-report-error'>
              <Chip
                className='cursor-pointer'
                icon={
                  <FontAwesomeIcon
                    icon={getIconStatus(mode?.text || 'editing')}
                    size='lg'
                    className='text-primary'
                  />
                }
                color='error'
                label={
                  <div>
                    <Typography variant='inherit' component={'p'} className='uppercase px-2'>
                      error
                    </Typography>
                  </div>
                }
              />
            </Tooltip>
          ) : (
            <Chip
              icon={
                <FontAwesomeIcon
                  icon={getIconStatus(mode?.text || 'editing')}
                  size='lg'
                  className='text-primary'
                  spin={mode?.text === 'saving'}
                />
              }
              label={
                <div>
                  <Typography variant='inherit' component={'p'} className='uppercase px-2'>
                    {mode?.text || 'editing'}
                  </Typography>
                </div>
              }
            />
          )}
        </>
      )}
      {permission && students.length > 0 && 
        <IconTooltipButton
          icon={'save'}
          onClick={onSaveCB}
          disabled={loadingSave || disabled}
          style={{
            borderRadius: '0.5rem',
            color: 'var(--primary-foreground)',
            backgroundColor: 'var(--primary)',
            padding: '0.45rem',
            opacity: loadingSave || disabled ? 0.5 : 1
          }}
          className='text-max color-main text-clickeable h-8 w-8'
          title='Save'
        />
      }
    </div>
  );
};

export default ButtonSave;
